export default "__VITE_ASSET__b9EZGXQ0__"